module.exports = __webpack_public_path__ + "img/software.62e55e5a.svg";